<template>
  <div>
    <b-alert
      :show="hasErrors"
      variant="danger"
    >
      <ul class="list-unstyled mb-0">
        <template v-for="Errors in errors">
          <li v-for="error in Errors">
            {{ error }}
          </li>
        </template>
      </ul>
    </b-alert>
  </div>
</template>

<script>
export default {
  computed: {
    errors() {
      return this.$page.props.errors
    },
    hasErrors() {
      return Object.keys(this.errors).length > 0
    },
  },
}
</script>
